import { Trans, useTranslation } from 'react-i18next';
import BlankPrimaryLayout from 'src/layouts/BlankPrimaryLayout';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import LogoMonkey from 'src/images/logo-monkey.svg?react';
import { AutoFloatingPanel } from 'src/components/common/AutoFloatingPanel';
import Button from 'src/components/common/designSystem/Button';
import LoginPanel from 'src/components/Login/LoginPanel';

// Welcome screen shown before login/signup
const Welcome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showLoginPanel, setShowLoginPanel] = useState(false);
  const [searchParams] = useSearchParams();

  const onCreateAccount = () => {
    // Go to type selection first
    navigate(`/onboarding/select-type?${searchParams.toString()}`);
  };

  const onHaveAccount = () => {
    setShowLoginPanel(true);
  };

  const handleEmailLogin = () => {
    setShowLoginPanel(false);
    navigate('/login/email?' + searchParams.toString());
  };

  const handleAfterSocialLogin = () => {
    setShowLoginPanel(false);
  };

  return (
    <BlankPrimaryLayout>
      <div
        className={
          'flex flex-col justify-between flex-1 w-full items-center relative p-4 py-10'
        }
      >
        <div />
        <LogoMonkey className={'w-auto h-48'} />
        <div className={'flex flex-col gap-4 w-full'}>
          <Button
            type="primary"
            className="font-bold w-full"
            onClick={onCreateAccount}
            data-testid="btn-create-account"
          >
            {t('onboarding.welcome.create_account')}
          </Button>
          <Button
            type={'text'}
            className="font-bold w-full !text-white"
            onClick={onHaveAccount}
            data-testid="btn-have-account"
          >
            {t('onboarding.welcome.have_account')}
          </Button>
          <div
            className={
              'text-center border-t-[1px] border-white border-opacity-50 pt-4 text-sm text-white text-balance w-full'
            }
          >
            <Trans i18nKey={'landing.footer'}>
              En continuant, j’accepte les{' '}
              <Link
                to={'/terms-and-conditions'}
                className={'font-extrabold text-white'}
              >
                conditions générales d’utilisation
              </Link>{' '}
              et{' '}
              <Link
                to={'/confidentialite'}
                className={'font-extrabold text-white'}
              >
                politiques de confidentialité
              </Link>
            </Trans>
          </div>
        </div>
      </div>

      {/* Login Panel */}
      <AutoFloatingPanel
        isOpen={showLoginPanel}
        onClose={() => setShowLoginPanel(false)}
        data-testid="login-panel"
      >
        <LoginPanel
          title={t('login.panel.child.title')}
          className="p-2"
          onLogin={handleAfterSocialLogin}
          onEmailClick={handleEmailLogin}
          allowFamilyCode
        />
      </AutoFloatingPanel>
    </BlankPrimaryLayout>
  );
};

export default Welcome;
